module.exports = __webpack_public_path__ + "static/media/waterways.7194835d.png";